module.exports = require("react-transition-group");


//////////////////
// WEBPACK FOOTER
// external "react-transition-group"
// module id = 18
// module chunks = 0